<template>
  <v-app>
    <v-main class="main pt-0">
      <MessageBox :props="snackbar" />
      <Appbar
        :scroll="scrollPosition"
        :open-appointment-window="
          () => {
            this.$refs.rview.openAppointmentWindow();
          }
        "
      />
      <router-view ref="rview" :snackbar="snackbar" :scroll="scrollPosition" />
      <Footer />
    </v-main>
  </v-app>
</template>

<script>
import Appbar from "./components/appbar/Appbar.vue";
import Footer from "./components/footer/Footer.vue";
import MessageBox from "./components/MessageBox.vue";

export default {
  name: "App",

  components: {
    Appbar,
    Footer,
    MessageBox,
  },

  data: () => ({
    scrollPosition: 0,
    snackbar: {
      show: false,
      text: null,
      color: null,
      timeout: 5000,
    },
  }),

  mounted() {
    window.addEventListener("scroll", this.updateScroll);
    this.updateScroll();
  },

  methods: {
    updateScroll() {
      this.scrollPosition = window.scrollY;
    },
  },
};
</script>

<style scoped lang="scss">
@import "@/scss/variables.scss";

.main {
  background-color: map-get($theme-colors, "dark-blue");
}
</style>
